
import "./reset.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useRef } from "react";

/* formulário */
import { useForm } from "react-hook-form";

/* funções auxiliares */
import { clearError, showError, registerLogOffline, formError } from "../../services/functions/functions.ts";

/* banco de dados */
import { auth } from "../../services/firebaseConnection";
import { sendPasswordResetEmail, verifyPasswordResetCode, confirmPasswordReset  } from "firebase/auth";

/* navegação */
import { Link } from "react-router-dom";

/* imagens */
import icon_success from "../../assets/sucesso.png";



export default function Reset() {

    const [step, setStep] = useState(0);
    const [error, setError] = useState("0");
    const [load, setLoad] = useState(false);

    const [oobCode, setOobCode] = useState(null);

    /* refs para tratamento de erros */
    const refEmail = useRef(null);
    const refErrorEmail = useRef(null);
    const refLabelEmail = useRef(null);

    const refSenha = useRef(null);
    const refErrorSenha = useRef(null);
    const refLabelSenha = useRef(null);

    const refConfSenha = useRef(null);
    const refErrorConfSenha = useRef(null);
    const refLabelConfSenha = useRef(null);

    const refError = useRef(null);



    const { handleSubmit, register, getValues } = useForm();

    useEffect(() => { window.scrollTo(0, 0); }, []);


    useEffect(() => {
    
        const query = new URLSearchParams(window.location.search);
        const code = query.get("oobCode");

        if(code) {
            verifyPasswordResetCode(auth, code).then(() => {
                setOobCode(code);
                setStep(2);
            })
            .catch(() => {
                setError("Link inválido ou expirado.");
            });
        }
    
    }, []);



    async function passo1(data) {

        const v_email = (email) => { let validate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; return validate.test(email); }

        let ma = data.email;
        if(!v_email(ma)) {
            showError(refEmail, refLabelEmail, refErrorEmail, "Esse email é inválido, verifique a digitação", setError, "email");
            return;
        }

        try {

            setLoad(true);
        
            await sendPasswordResetEmail(auth, ma, {url: "https://winners-ai.com/reset"});
        
            registerLogOffline("/reset_senha_step1/email=" + ma);
            setStep(1);

            setLoad(false);

        }
        catch(erro) {
            console.log("tratar o erro");
        }

    }


    async function passo3(data) {

        formError(refError, "", false);

        const senha = data.senha;
        const confsenha = data.confsenha;

        if(senha.length < 6) {
            showError(refSenha, refLabelSenha, refErrorSenha, "A senha deve ter entre 6 a 12 caracteres", setError, "senha");
            return;
        }
        
        if(senha !== confsenha) {
            showError(refConfSenha, refLabelConfSenha, refErrorConfSenha, "A confirmação da senha não está igual a senha", setError, "senha");
            return;
        }

        try {

            setLoad(true);

            await confirmPasswordReset(auth, oobCode, senha);
            
            registerLogOffline("/reset_senha_step3/email=" + getValues("email"));
            setStep(3);

            setLoad(false);

        } catch (erro) {
            console.log("Não foi possível redefinir a senha.");
        }

    }




    return(
        <div className="context">

            <Header access={0}></Header>

            <div className="content">
                
                    
                    { step === 0 && (
                    <>
                    <div className="ft_topico">Esqueci minha senha</div>
                    <div className="ft_descricao">Vamos resetar sua senha, para isso, precisamos validar seu email.</div>
                    <div className="space"></div>

                    <div className="border_form reset_border_form">
                        <form className="form" onSubmit={handleSubmit(passo1)}>
                            <span className="step_form">
                                <span className="step_form_number">Passo 1/3</span>
                                <span className="step_form_description">&nbsp;. Email</span>
                            </span>
                            <span className="space_form"></span>

                            <span className="title_form">Alterar a senha</span>
                            <span className="subtitle_form">Siga corretamente os passos abaixo para trocar sua senha.</span>
                            <span className="space_form"></span>

                            <span ref={refErrorEmail} className="error_form"></span>
                            <label for="inp" className="inp" ref={refLabelEmail}>
                            <input type="text" placeholder="&nbsp;" maxLength={60} {...register("email")} ref={(el) => {refEmail.current = el; register("email").ref(el);}} onClick={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onChange={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)}></input>
                            <span className="label">Digite seu email</span>
                            <span className="focus-bg"></span>
                            </label>
                            <span className="space_form"></span>

                            <button type="submit" name="bt1" className={load ? "button_disabled_form" : "button_form"} disabled={load}>{load ? "AGUARDE ..." : "AVANÇAR"}</button>
                        </form>
                    </div>
                    </>
                    )}


                    { step === 1 && (
                    <>
                    <div className="ft_topico">Esqueci minha senha</div>
                    <div className="ft_descricao">Vamos resetar sua senha, para isso, precisamos validar seu email.</div>
                    <div className="space"></div>

                    <div className="border_form reset_border_form">
                        <form className="form">
                            <span className="step_form">
                                <span className="step_form_number">Passo 2/3</span>
                                <span className="step_form_description">&nbsp;. Verifique seu email</span>
                            </span>

                            <span className="space_form"></span>

                            <span className="subtitle_form">1. Enviamos um link para redefinir sua senha.</span>
                            <span className="subtitle_form">2. Acesse sua caixa de entrada e clique no link para continuar.</span>
                            <span className="reset_obs">*Caso não encontre, verifique a pasta de spam.</span>
                        </form>
                    </div>
                    </>
                    )}


                    { step === 2 && (
                    <>
                    <div className="ft_topico">Esqueci minha senha</div>
                    <div className="ft_descricao">Agora você já pode definir uma nova senha.</div>
                    <div className="space"></div>

                    <div className="border_form reset_border_form">
                        <form className="form" onSubmit={handleSubmit(passo3)}>
                            <span className="step_form">
                                <span className="step_form_number">Passo 3/3</span>
                                <span className="step_form_description">&nbsp;. Definir a senha</span>
                            </span>
                            <span className="space_form"></span>

                            <span className="title_form">Nova senha</span>
                            <span className="subtitle_form">Agora, defina uma nova senha e confirme-a.</span>
                            <span className="space_form"></span>

                            <span ref={refErrorSenha} className="error_form"></span>
                            <label for="inp" className="inp" ref={refLabelSenha}>
                            <input type="password" placeholder="&nbsp;" maxLength={12} {...register("senha")} ref={(el) => {refSenha.current = el; register("senha").ref(el);}} onClick={() => clearError(refSenha, refLabelSenha, refErrorSenha, error, setError)} onChange={() => clearError(refSenha, refLabelSenha, refErrorSenha, error, setError)}></input>
                            <span className="label">Digite a senha</span>
                            <span className="focus-bg"></span>
                            </label>
                            <span className="space_form"></span>

                            <span ref={refErrorConfSenha} className="error_form"></span>
                            <label for="inp" className="inp" ref={refLabelConfSenha}>
                            <input type="password" placeholder="&nbsp;" maxLength={12} {...register("confsenha")} ref={(el) => {refConfSenha.current = el; register("confsenha").ref(el);}} onClick={() => clearError(refConfSenha, refLabelConfSenha, refErrorConfSenha, error, setError)} onChange={() => clearError(refConfSenha, refLabelConfSenha, refErrorConfSenha, error, setError)}></input>
                            <span className="label">Confirme a senha</span>
                            <span className="focus-bg"></span>
                            </label>
                            <span className="space_form"></span>
                            <span ref={refError} className="error_form"></span>
                            <span className="space_form"></span>

                            <button type="submit" name="bt2" className={load ? "button_disabled_form" : "button_form"} disabled={load}>{load ? "AGUARDE ..." : "ALTERAR SENHA"}</button>
                        </form>
                    </div>
                    </>
                    )}


                    { step === 3 && (
                    <>
                    <div className="ft_topico">Senha alterada</div>
                    <div className="ft_descricao">Sua senha foi alterada com sucesso.</div>
                    <span className="space"></span>
                    <img className="reset_image" src={icon_success}></img>
                    <span className="space"></span>
                    <span className="reset_success_01">Você já poderá acessar a Plataforma clicando no botão abaixo</span>                
                    <span className="space"></span>
                    <div className="reset_button"><Link to="/login" className="button_form">ACESSAR A PLATAFORMA</Link></div>
                    </>
                    )}
                
                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>

            <Footer access={0}></Footer>

        </div>
    )
}